module.exports = __webpack_public_path__ + "img/portfolio-1.c30273e3.jpg";